import { Component, OnInit } from '@angular/core';
import { Post } from '../post'
import { Article1Component } from '../article1/article1.component'
import { PostService } from '../post.service'
import { LoginService } from '../login.service'

import { Router } from '@angular/router'



@Component({
  selector: 'app-posts',
  templateUrl: './posts.component.html',
  styleUrls: ['./posts.component.css'],
})
export class PostsComponent implements OnInit {
  posts:Post[]
  tmpId = 0;
  
  constructor(private postService: PostService, private loginService: LoginService, private router:Router) { }
  

  ngOnInit() {
    if(this.router.url.length>0)
      this.getPosts(this.router.url.substring(1, this.router.url.length))
    else
      this.getPosts()
    //console.log(this.router.url)
    //this.categoryService.observable.subscribe(data => this.getPosts(data))
  }
  getPosts(category?:string):void{
    this.postService.getPosts(category).subscribe((posts: Post[]) => {this.posts = posts;/*this.posts[0].editing = true*/})
  }
  savePost(post:any){
    //todo check if its being used
    //this.postService.savePost(post)
  }
  newPost(){
    var category = 'inicio'
    if(this.router.url.length>0)
      category = this.router.url.substring(1, this.router.url.length)
    
    this.posts.unshift({'id':this.tmpId--,'category':category, 'timestamp':'','type': 'article1','component':{}, 'editing':true})
  }
  onRemove(id:number){
    for (var i = 0; i < this.posts.length; ++i) {
      if(this.posts[i].id == id){
        console.log(this.posts[i].component.data.title)
        this.posts.splice(i, 1)
      }
    }
    
  }
}



// WEBPACK FOOTER //
// ./src/app/posts/posts.component.ts